import * as React from 'react';
import { IListViewFieldColumn } from "../../../../../services/ViewService";
import { ProjectInfo, ProjectInfo as IProjectInfo } from "../../../../../store/ProjectsListStore";
import { SourceTypeMap } from "../../../../../store/ExternalEpmConnectStore";
import { SourceInfo } from "../../../../../entities/common";
import { Field } from "../../../../../entities/Metadata";
import { ExpandedMultilineTextFormatter } from '../../../../common/formatters/ExpandedMultilineTextFormatter';
import { TextFormatter } from '../../../../common/formatters/TextFormatter';

export default class SyncDetails extends React.Component<IListViewFieldColumn<ProjectInfo>> {
    public render() {
        const field = this.props.field;

        if (!field) {
            return <span>Invalid column configuration</span>;
        }

        const failedSources = SourceInfo.getSyncableConnections(this.props.entity.sourceInfos)
            .filter(_ => !!_.syncStatus.lastException || !!_.syncStatus.warnings?.length);
        
        if (!failedSources.length) {
            return <></>;
        }

        const message = failedSources
            .filter(_ => !!_.syncStatus.lastException)
            .map(source => `${SourceTypeMap[source.type]}: ${source.syncStatus.lastException}`)
            .concat(failedSources
                .filter(_ => !!_.syncStatus.warnings?.length)
                .map(source => `${SourceTypeMap[source.type]}: ${source.syncStatus.warnings?.map(w => w.text).join("\n")}`)
            )
            .join("\n");
        
        return this.props.isTimelineView
            ? <TextFormatter isMultiline value={message} className='selectable-text sync-details-column' />
            : <span className='list-grid-cell'>
                <ExpandedMultilineTextFormatter isMultiline value={message} className='selectable-text' />
            </span>;
    }

    public static getValue(entity: IProjectInfo, field: Field): string | undefined {
        const failedSources = SourceInfo.getSyncableConnections(entity.sourceInfos)
            .filter(_ => !!_.syncStatus.lastException);
        return failedSources.length ? failedSources[0].syncStatus.lastException : undefined;
    }

    public static getSearchValue(entity: IProjectInfo, field: Field) {
        return SyncDetails.getValue(entity, field);
    }
}